module.exports = __webpack_public_path__ + "static/media/me.621128ef.JPG";